var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgIconGameCam = (_ref) => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.286 4H9.57L7 6.571V19.43L9.571 22h7.715l2.571-2.571V6.57L17.286 4zm-3.857 12.857a1.286 1.286 0 1 1 0-2.571 1.286 1.286 0 0 1 0 2.571zm0-5.786a1.929 1.929 0 1 1 0-3.857 1.929 1.929 0 0 1 0 3.857z",
    fill: "#1A202C"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconGameCam, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon-game-cam.8e45bdb4.svg";
export { ForwardRef as ReactComponent };